import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, NgForm, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router"
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, Observer } from 'rxjs';

import { UsuarioService } from '../../../services/usuario.service';


@Component({
    selector: 'app-usuario-lancamento',
    templateUrl: './usuario-lancamento.component.html',
    styleUrls: ['./usuario-lancamento.component.css'],
    standalone: false
})

export class UsuarioLancamentoComponent implements OnInit {
  usuarioForm!: UntypedFormGroup;
  id = null;
  dataUsuarioAtt = null;

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
    private usuarioService: UsuarioService,

  ) {
    this.usuarioForm = this.newFormUsuario();

    this.route.params.subscribe(res => this.id = res.id);
  }

  ngOnInit(): void {
    if (this.id !== undefined) {
      this.usuarioService.detalhar(this.id).subscribe((p: any) => {
        let item = p.data.usuario;
        this.dataUsuarioAtt = item;
        this.usuarioForm.get('id').setValue(item.id);
        this.usuarioForm.get('name').setValue(item.name);
        this.usuarioForm.get('email').setValue(item.email);
        this.usuarioForm.get('tipo').setValue(item.tipo);
        this.usuarioForm.get('password').disable();
        this.usuarioForm.get('confirmar_password').disable();
      });
    } else {
      this.usuarioForm.reset();
      this.usuarioForm.controls['password'].setValidators([Validators.required]);

    }
  }

  confirmationValidator = (control: UntypedFormControl): { [s: string]: boolean } => {

    if (!this.id) {
      if (!control.value) {
        return { required: true };
      } else if (control.value !== this.usuarioForm.controls.password.value) {
        return { confirm: true, error: true };
      }
    }
    return {};
  };

  validaEmail = (control: UntypedFormControl) =>
    new Observable((observer: Observer<ValidationErrors | null>) => {
      this.usuarioService.searchEmail(control.value).subscribe((m: any) => {
        let total = m.data.usuario.total;
        if (control.value) {
          if (total > 0) {
            if (this.id !== undefined && this.dataUsuarioAtt.email === control.value) {
              observer.next({});
            } else {
              observer.next({ error: true, duplicated: true });
            }

          } else {
            observer.next({});
          }
        } else {
          observer.next({ error: true, required: true });
        }
        observer.complete();
      });

    });
  newFormUsuario() {
    return new UntypedFormGroup({
      id: new UntypedFormControl(''),
      name: new UntypedFormControl('', [Validators.required]),
      tipo: new UntypedFormControl('', [Validators.required]),
      email: new UntypedFormControl('', [Validators.required, Validators.email], [this.validaEmail]),
      password: new UntypedFormControl(''),
      confirmar_password: new UntypedFormControl('', [this.confirmationValidator]),
    });
  }

  onSubmitUsuario() {
    if (this.usuarioForm.valid) {
      let id = this.message.loading('Salvando cadastro...').messageId;
      if (this.id !== undefined) {
        let dadosEdicao = this.usuarioForm.value;
        delete dadosEdicao.password;
        delete dadosEdicao.confirmar_password;

        this.usuarioService.atualizar(dadosEdicao).subscribe((p: any) => {
          this.router.navigate(['/usuario']);
          this.message.remove(id);
          this.message.success('O usuário foi atualizado com SUCESSO!');
        });

      } else {
        
        this.usuarioService.criar(this.usuarioForm.value).subscribe((p: any) => {
          this.message.remove(id);
          this.router.navigate(['/usuario']);
          this.message.success('O usuário foi cadastrado com SUCESSO!');
        });
      }

    } else {
      for (const i in this.usuarioForm.controls) {
        this.usuarioForm.controls[i].markAsDirty();
        this.usuarioForm.controls[i].updateValueAndValidity();
      }
    }
  }

  onBack() {
    this.router.navigate(['/usuario']);
  }

  changeTipo(tipo: any){
    if(tipo === 'ADMINISTRADOR'){
      this.usuarioForm.get('password').enable();
      this.usuarioForm.get('confirmar_password').enable();
      this.usuarioForm.controls['password'].setValidators([Validators.required]);
    }else{
      this.usuarioForm.get('password').disable();
      this.usuarioForm.get('confirmar_password').disable();
      this.usuarioForm.controls['password'].setValidators([]);
    }
  }

}